<div class="row px-4 pt-2 pb-4">
  <sacbo-free-ticket-element class="col-12" [mainProductId]="idProduct" (updated)="loadRelated()"></sacbo-free-ticket-element>
  <sacbo-free-ticket-element class="col-12 pt-4" [mainProductId]="idProduct" (updated)="loadRelated()" *ngFor="let product of relatedProducts" [relatedProduct]="product"></sacbo-free-ticket-element>
</div>